import React from "react";

import { Trans } from "@lingui/macro";

import { Box, Typography } from "@mui/material";

import type { IntegrationProvider } from "@app/common/types";

import Button from "@rui/Button";
import { Link } from "@rui/Link";

import { LogoMenuItem, MenuItemRow } from "./styles";

interface PushMenuItemProps {
  provider: IntegrationProvider;
  className?: string;
  disabled: boolean;
  isConnected: boolean;
  onClick: () => void;
}

const PushMenuItem = ({
  provider,
  className,
  disabled,
  isConnected,
  onClick,
}: PushMenuItemProps) => {
  return (
    <LogoMenuItem className={className} disabled={disabled} onClick={onClick}>
      <MenuItemRow>
        <Box>
          <img src={provider.icon} alt={provider.displayNameShort} />
        </Box>
        <Typography variant="bodySecondaryReg" sx={{ flex: 1 }}>
          {provider.displayNameShort}
        </Typography>
        {!isConnected && (
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to={provider.integrationUrl}
            sx={{
              height: "fit-content",
              width: "fit-content",
              minWidth: 0,
              px: 1,
              py: 0.5,
            }}
          >
            <Trans>Add</Trans>
          </Button>
        )}
      </MenuItemRow>
    </LogoMenuItem>
  );
};

export default PushMenuItem;
